import { render, staticRenderFns } from "./tuihuo-details.vue?vue&type=template&id=635d0d5d&scoped=true"
import script from "./tuihuo-details.vue?vue&type=script&lang=js"
export * from "./tuihuo-details.vue?vue&type=script&lang=js"
import style0 from "./tuihuo-details.vue?vue&type=style&index=0&id=635d0d5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d0d5d",
  null
  
)

export default component.exports